<template lang="pug">
  fpui-input-select.fpui-select-dynamic-parameters(
    v-model="model",
    :multiple='multiple',
    :options="options",
    :searchable='true'
    :clearable='clearable'
    :placeholder='placeholder'
    :disabled='true'
  )
</template>

<script>
  import get from 'lodash/get'

  export default {
    props: {
      value: { type: [Array, String] },
      filters: { type: Array },
      multiple: { type: Boolean, default: true },
      placeholder: { type: String },
      clearable: { type: Boolean, default: false }
    },
    data () {
      return {
        charts: []
      }
    },
    created () {
      if (this.$store.state.architect && this.dashboard) {
        this.charts = this.charts.concat(this.recursiveExploreDashboard(this.dashboard.items))
      } else {
        let dashboards = get(this.$store, 'state.app.config.dashboarding')
        if (dashboards) {
          Object.values(dashboards).forEach(dashboard => {
            if (Array.isArray(dashboard.items)) {
              this.charts = this.charts.concat(this.recursiveExploreDashboard(dashboard.items))
            }
          })
        }
      }
    },
    computed: {
      dashboard () { return get(this.$store, 'state.config.app.dashboard') },
      model: {
        get () { return this.value },
        set (val) { this.$emit('input', val) }
      },
      // Disabled for the moment because we can't update the charts from the dynamic-parameters settings for now
      options () {
        let options = this.charts.map((chart) => {
          const value = chart.label || chart.chart.id || chart.chart.component
          return {
            value,
            label: chart.label || chart.chart.id
          }
        })
        if (this.filters) {
          options = options.filter(option => this.filters.indexOf(option.value) !== -1)
        }
        return options
      }
    },
    methods: {
      recursiveExploreDashboard (items) {
        let res = []
        items.forEach((item) => {
          if (item && item.type === 'chart' && item.chart.id) res.push(item)
          if (item && item.items) res = res.concat(this.recursiveExploreDashboard(item.items))
        })
        return res
      }
    }
  }
</script>

<style lang="less">
</style>
